import api from '../../lib/api';
import { useQuery } from 'react-query';

export function useFetchCampaignTypesData(config = {}) {
  const fetchURL = 'campaign_types';
  const fetchFunc = async () => await api.get(fetchURL);
  return useQuery('campaignTypes', fetchFunc, config);
}
